import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Employee } from '@qaroni-app/employee/types/employee';

@Component({
  selector: 'qaroni-profile-status-progressbar',
  templateUrl: './profile-status-progressbar.component.html',
  styleUrls: ['./profile-status-progressbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProfileStatusProgressbarComponent {
  readonly employee = input<Employee | null>(null);
}
